module.exports = __webpack_public_path__ + "static/media/saturn.a6bcae98.jpg";